import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
import { ResponseFilterLicense } from '../../../../../interfaces/reports/reports';

@Component({
  selector: 'app-report-table-licences',
  templateUrl: './report-table-licences.component.html',
  styleUrls: ['./report-table-licences.component.css'],
})
export class ReportTableLicencesComponent {

  @Input() detailLicenseByFilter: ResponseFilterLicense[] = []
  @Output() exportToExcel = new EventEmitter<any>();
  @Input() pageCount: number = 6
  @Input() listCountForPages: number[] = [];

  constructor(private orderPipe: OrderPipe) {
    this.detailLicenseByFilter = this.detailLicenseByFilter.slice();
    this.collectionToOrder = this.orderPipe.transform(this.detailLicenseByFilter, 'detailLicenseByFilter.id');

  }

  @Output() next = new EventEmitter<any>();
  @Output() previus = new EventEmitter<any>();
  @Output() toNumber = new EventEmitter<number>();

  //  ------> sorting activities  <-------
  orderActivities: string = ''
  reverse: boolean = false;
  collectionToOrder: Partial<ResponseFilterLicense[]>;

  order: string = ''
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  //  ------> paginate activities  <-------

  goNext() {
    this.next.emit();
  }
  goPrevius() {
    this.previus.emit();
  }
  goTonumber(index: number) {
    this.toNumber.emit(index);
  }

  public config: any = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    pages: this.pageCount,
    totalItems: this.detailLicenseByFilter.length,
  };

  public maxSize: number = 30;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    previousLabel: '<',
    nextLabel: '>',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: 'You\'re on page',
  };

  searchText = '';

  export() {
    this.exportToExcel.emit();
  }
}
